export const guestApps: { [key: string]: any }[] = [
 {
    "classes": "56",
    "topic": "פעולות חשבון בשברים",
    "top_topic": "שבר",
    "youtube": "dXhV_0pDEeM",
    "lesson_id": "Division_to_fraction",
    "app": "השבר כמנת חילוק- יישומון",
    "plus": "0",
    "app_arabic": "الكسر كفسمة ـ التطبيق",
    "search_words": "",
    "interaction": "",
    "student_page": "",
    "description": "היישומון מיועד לתלמידים בכיתות ה-ו, והוא מאפשר להסביר בצורה פשוטה וויזואלית את הרעיון של השבר כמנת חילוק – מדוע, כאשר מחלקים למשל 4 פיצות ל- 5 ילדים, כל ילד מקבל ארבע חמישיות של פיצה.  ",
    "description_arabic": "التطبيق معد لتلاميذ الصفوف الخامس والسادس، يمكن من تفصير بشكل بسيط ومرئي فكرة الكسر كفسمة ـ لماذا، عندما نفسم مثلا 4 بيتسا علة 5 اولاد، كل ولد يأخذ خمس البيتسا.   ",
    "app_eng": "The Fraction as a solution to a division problem",
    "youtube_eng": "",
    "description_eng": "",
    "search_words_eng": "",
    "": "",
    "flash": "",
    "category": "המחשה",
    "origin": "apps",
    "liked": 0,
    "selected": 0,
    "viewed": 0,
    "totalLikes": 0,
    "studentScores": 0
  },
  {
    "classes": "456",
    "topic": "פעולות חשבון בשברים",
    "top_topic": "שבר",
    "youtube": "BD_p--lk5Bs",
    "lesson_id": "Whole_times_fraction_page",
    "app": "שלם כפול שבר",
    "plus": "0",
    "app_arabic": "عدد كامل صرب كسر  ",
    "search_words": "שברים  ",
    "interaction": "",
    "student_page": "",
    "description": "היישומון מבוסס על מודל העיגולים לייצוג שברים, ובאמצעותו ילמדו התלמידים לפתור בצורה חזותית תרגילי כפל שאחד מן המוכפלים בהם הוא מספר שלם, ואילו השני - שבר (או מספר מעורב). העבודה החזותית תפתח אצל התלמידים את היכולת לפתור בראש תרגילים דומים, בזמן שהם מדמיינים את הייצוגים החזותיים שהופיעו ביישומון.  ",
    "description_arabic": "يعتمد التطبيق على موديل الدوائر لعرض الكسور. بواسطته يتعلم التلاميذ حل بشكل بصري تمارين ضرب احد المضروبين هو عدد كامل، بينما الثاني هو كسر (أو عدد مختلط). العمل البصري تطور لدى التلاميذ القدرة على حل تمارين مشاية . حين يتخيلون العروض البصرية التي ظهرت في التطبيق. ",
    "app_eng": "Whole times a Fraction",
    "youtube_eng": "",
    "description_eng": "",
    "search_words_eng": "fractions",
    "": "",
    "flash": "_fractions_whole_times_medume",
    "category": "שיטת פתרון",
    "origin": "apps",
    "liked": 0,
    "selected": 0,
    "viewed": 0,
    "totalLikes": 0,
    "studentScores": 0
  },
  {
    "classes": "123456",
    "topic": "המבנה העשרוני",
    "top_topic": "שלמים",
    "youtube": "69yQ2SHbZeA",
    "lesson_id": "Bills_and_coins",
    "app": "מטבעות ושטרות",
    "plus": "0",
    "app_arabic": "قطع نقود وأاوراق نقدية ",
    "search_words": "המבנה העשרוני  כסף",
    "interaction": "",
    "student_page": "",
    "description": "היישומון מציג מטבעות ושטרות של ישראל. היישומון מאפשר לפרוט את המטבעות והשטרות האלה, ואף לאחד קבוצה לקבלת המטבע או השטר שהוא הסכום שלהם. היישומון מאפשר להסביר לתלמידים בנוחות את נושא המבנה העשרוני של המספר באמצעות שימוש במטבעות של שקל אחד ו- 10 שקלים ובשטרות של 100 שקלים.",
    "description_arabic": "التطبيق يعرض نقود وأوراق نقدية اسرائيلية،  التطبيق يمكن من فرط النقود والأوراق النقدية. وحتى يمكن توحيد مجموعة اانقود ختى الحصول على مجموعها، التطبيق يمكن التلاميذ بسهولة يوصح مينى العشري لكل الأعداد بواسطة استخدام قطعة نقدية من فئة شيكل واحد و 10 شيكل وباوراق نقدية من فئة 100 شيكل.   ",
    "app_eng": "Bills and Coins",
    "youtube_eng": "",
    "description_eng": "",
    "search_words_eng": "the decimal structure",
    "": "",
    "flash": "",
    "category": "כלי",
    "origin": "apps",
    "liked": 0,
    "selected": 0,
    "viewed": 0,
    "totalLikes": 0,
    "studentScores": 0
  },
  {
    "classes": "123456",
    "topic": "תרגולים בפעולות החשבון",
    "top_topic": "שלמים",
    "youtube": "FBFvOinAhoY",
    "lesson_id": "Inserting_numbers_games",
    "app": "תחרות התבניות",
    "plus": "0",
    "app_arabic": "مناقسة القوالب  ",
    "search_words": "חיבור, חיסור, שברים, כפל, חילוק, השוואה, חשיבה אלגברית, דו ספרתי, דו-ספרתי, תלת ספריתי, תלת-ספרתי, משחק",
    "interaction": "",
    "student_page": "",
    "description": "יישומון זה מכיל מספר משחקים אותם ניתן לשחק החל מכיתה א' ועד לכיתה ו'. בכל משחק יש לכל שחקן 3 תבניות חשבוניות בהן עליו למקם ספרות. בכל שלב מגריל מורה הכיתה ספרה אחת עבור אחד מהשחקנים. השחקן ממקם את הספרה הזו באחת מהתבניות שלו. מול כל תבנית של שחקן א' יש תבנית של שחקן ב'. המטרה של כל שחקן היא לקבל תוצאות בתבניות שלו שהן גבוהות יותר מהתוצאות המתאימות של יריבו. יש כאן פיתוח של חשיבה מספרית ושל חשיבה אלגברית וגם תרגול של רעיון האומדן.",
    "description_arabic": "هذا الطبيق يحوي عدة لاعبين يمكن أن يلعبوا ابتداء من الصف الأول حتى الصف السادس. في كل لعبة يوحد لكل لاعب 3 تمارين حسابية يجب أن يضع فيها أرقام، في كل مرحلة يغرض فيها المعلم احد الأرقام للاعب واحد، اللاعب يضع الرقم في احدى التمارين. امام كل لاعب أ  تمرين لاعب ب. الهدف لكل لاعب أن يحصل على نتائج في تمريناته اعلى من النتائج لدى منافسه. يوجد هنا تفكير عددي وتفكير حسابي وتفكير جبري وكذلك تدرب على فكرة القياس.  י ",
    "app_eng": "Number sense game",
    "youtube_eng": "",
    "description_eng": "",
    "search_words_eng": "addition, subtraction, fractions, multiplication, difference, comparison, algebraic thinking, double-digit, double-digit, three-digit, three-digit, game",
    "": "",
    "flash": "",
    "category": "משחק",
    "origin": "apps",
    "liked": 0,
    "selected": 0,
    "viewed": 0,
    "totalLikes": 0,
    "studentScores": 0
  },
  {
    "classes": "1234567",
    "topic": "ציר",
    "top_topic": "ציר",
    "youtube": "Tj7LfgQKRJY",
    "lesson_id": "Axis2",
    "app": "ישר המספרים",
    "plus": "0",
    "app_arabic": "محور الأعداد  ",
    "search_words": "שנתות עשרוני שבר שליליים ציר המספרים",
    "interaction": "",
    "student_page": "",
    "description": "היישומון מאפשר לבנות כמעט כל שאלה מספר הלימוד שמופיע בה ציר המספרים, ולהציג אותה לתלמידים. העבודה כאן נוחה ואינטראקטיבית.",
    "description_arabic": "التطبيق يمكن أن يؤدي التلاميذ لأثبات قانون فيتاغورس بدون استخدام التلاعب الجبري.    ",
    "app_eng": "Axis",
    "youtube_eng": "",
    "description_eng": "",
    "search_words_eng": "line, linear, tick marks",
    "": "",
    "flash": "_topics_zir",
    "category": "כלי",
    "origin": "apps",
    "liked": 0,
    "selected": 0,
    "viewed": 0,
    "totalLikes": 0,
    "studentScores": 0
  },
  {
    "classes": "12",
    "topic": "המבנה העשרוני",
    "top_topic": "שלמים",
    "youtube": "WEZ5gzcKW7g",
    "lesson_id": "Hundred_board",
    "app": "לוח המאה",
    "plus": "0",
    "app_arabic": "لوح المئة",
    "search_words": "",
    "interaction": "",
    "student_page": "",
    "description": "לוח המאה הוא כלי שימושי בכיתה א ו- ב. היישומון שלפנינו מאפשר לחשוף מספרים אחדים מן הלוח הזה, לסמן בצבעים משבצות שהמספרים בהן מוסתרים ולבקש מן התלמידים לנסות ולגלות את המספרים האלה. כמו כן אפשר לשנות את מספר עמודות הלוח, מה שעשוי להוסיף עניין רב לחקירת המספרים שעליו",
    "description_arabic": "لوح المئة هو اداة مستخدمة في الصفين الأول والثاني، التطبيق الذي امامنا يتيح كشف ارقام معينة من هذا اللوح، تاشير بالوان مربعات التي فيها الأرقام غير مرئية والطلب من التلاميذ محاولة اكتتشاف هذه الأرقام، كما انه يمكن تغيير اعمدة اللوح، مما يزيد من اهتمام كثير لبحث الأرقام. ",
    "app_eng": "The hundred board",
    "youtube_eng": "",
    "description_eng": "",
    "search_words_eng": "",
    "": "",
    "flash": "_other_luach_mea",
    "category": "כלי",
    "origin": "apps",
    "liked": 0,
    "selected": 0,
    "viewed": 0,
    "totalLikes": 0,
    "studentScores": 0
  },
  {
    "classes": "34",
    "topic": "מגוון נושאים בגיאומטרייה",
    "top_topic": "גיאומטרייה",
    "youtube": "zC5v2JbHr4g",
    "lesson_id": "Paralel",
    "app": "ישרים מקבילים ומאונכים",
    "plus": "0",
    "app_arabic": "مستقيمات متوازية ومتعامدة  ",
    "search_words": "תשעים מעלות ישר קו קווים מקביל ",
    "interaction": "",
    "student_page": "",
    "description": "היישומון מיועד לתלמידים החל מכיתה ג', והוא עוסק בזיהוי של ישרים מקבילים ומאונכים. על המסך מופיע קו (ראשון) ונקודות. יש לגלות שתי נקודות שאם מחברים אותן מתקבל קו המקביל או המאונך לקו הראשון.",
    "description_arabic": "التطبيق ملائم لتلاميذ الصفين الخامس والسادس،  وهو يمكن التعلم بصورة سهلة ، بصرية وحركية موضوع الارتفاع في متوازي الأضلاع،   التعريف الذي سنستخدمه هو \"ارتفاع في متوازي الأضلاع هو يحرج من ضلع واحدة في متوازي الأضلاع، وهو ينتهي على الضلع المقابل او على استمرارها عندما يتعامد معها.  ",
    "app_eng": "Parallel and Perpendicular Lines",
    "youtube_eng": "",
    "description_eng": "",
    "search_words_eng": "ninety degrees, right angle",
    "": "",
    "flash": "",
    "category": "המחשה",
    "origin": "apps",
    "liked": 0,
    "selected": 0,
    "viewed": 0,
    "totalLikes": 0,
    "studentScores": 0
  },
  {
    "classes": "456",
    "topic": "זוויות",
    "top_topic": "גיאומטרייה",
    "youtube": "dkCGR4jrW4M",
    "lesson_id": "Angle_game",
    "app": "משחק התאמת הזוויות",
    "plus": "0",
    "app_arabic": "لعبة ملاءمة الزوايا  ",
    "search_words": "זווית, זוויות, ישר  חד  קהה   שוות זויות ",
    "interaction": "",
    "student_page": "",
    "description": "היישומון מיועד להוראה בכיתות ד-ו, והוא עוסק בהבנת מושג הזווית. בכל משחק יופיעו ציורים של 10 זוויות כשהמשימה היא לחלק אותן לזוגות של זוויות שוות. קושי ראשון נובע מכך שהקרניים המצוירות של כל זווית הן באורכים שונים. הקושי השני נובע מכך שהזוויות גם משורטטות בהטיות שונות. בנוסף, במשחק יש אופציה לבקש מהתלמידים לגלות את הגודל המדויק במעלות של כל זווית.",
    "description_arabic": "التطبيق معد للتعليم في الصفوف الرابع حتى الصف السادس، وهو يتناول فهم مصطلح الزاوية،  في كل لعبة يظهر رسوم لـ 10 زوايا ومهمة التلاميذ تقسيم الزوايا الة أزواج زوايا ممتساوية. صعوبة اولى تنيع من اضلاع الزوايا المرسومة هي باطوال مختلفة. الصعوبة الثانية هي أن الزوايا مرسومة بميلان مختلف. بالاضافة، في اللعبة امكانية ان نطلب مت التلاميذ اكتشاف الحجم الدقيق بالدرجات لكل زاوية.  ",
    "app_eng": "",
    "youtube_eng": "",
    "description_eng": "",
    "search_words_eng": "angle, angles, acute, right, obtuse",
    "": "",
    "flash": "",
    "category": "משחק",
    "origin": "apps",
    "liked": 0,
    "selected": 0,
    "viewed": 0,
    "totalLikes": 0,
    "studentScores": 0
  }
];






export const guestLessons: { [key: string]: any }[] = [

  {
    "classes": "45",
    "lesson_id": "12293",
    "app": "השבר כמנת חילוק",
    "plus": "1",
    "app_topic": "",
    "app_arabic": "الكسر كخارج قسمة ",
    "search_words": "",
    "youtube": "3t6U1KOjJ2o",
    "father_app": "Fraction_circle_model",
    "interaction": "0",
    "teacher_page": "השבר כמנת חילוק-למורה",
    "teacher_page_ar": "השבר כמנת חילוק-למורה בערבית",
    "student_page": "השבר כמנת חילוק - דף משימה",
    "student_page_ar": "השבר כמנת חילוק - דף משימה-בערבית",
    "enrichment": "",
    "enrichment_ar": "",
    "arabic": "22355",
    "description": "השיעור מיועד לתלמידים בכיתות ד-ה, והוא מציג בפניהם חידה ידועה ומרתקת על אנשים הנכנסים בזה אחר זה לפיצריה שבה מצויים שלושה שולחנות. על שולחן אחד פיצה אחת, על השני 2 פיצות ועל השלישי 3 פיצות. כל אדם שנכנס לפיצרייה חושב שהוא האחרון, והוא מעוניין להתיישב בשולחן בו יקבל את חלק הפיצה הגדול ביותר (הוא יחלוק שם שווה בשווה את הפיצות עם יתר האנשים היושבים סביב אותו השולחן). החידה מוליכה להבנת הקשר בין השבר כחלק מכמות לבין השבר כמנת חילוק. ",
    "description_arabic": "الدّرس مُعدّ لتلاميذ الصف الرابع والخامس. يعرض الدرس أمام التلاميذ أحجية معروفة  وجذّابة حول أشخاص يدخلون الواحد تلو الآخر لمطعم بيتزا فيه ثلاث طاولات. على طاولة واحدة يوجد قرص بيتزا واحد، على الثانية قرصي بيتزا وعلى الثالثة ثلاثة أقراص بيتزا. كل شخص يدخل للمطعم يعتقد بأنه الشخص الأخير الذي يدخل للمطعم، ولذلك يهتم بأن يجلس حول طاولة يحصل فيها على أكبر حصّة من البيتزا (يتقاسم الشخص مع الأشخاص الآخرين الذين يجلسون حول نفس الطاولة أقراص البيتزا التي على الطاولة بالتساوي). تؤدّي الأحجية إلى فهم العلاقة بين الكسر كجزء من كميّة والكسر كخارج قسمة. ",
    "flash": "https://www.yisumatica.org.il/flash?lang=he&file=flash/_fractions_general/hashever_kemanat_hiluk/swf",
    "father_app_heb": "שברים במודל העיגולים",
    "origin": "lessons",
    "liked": 0,
    "selected": 0,
    "viewed": 0,
    "totalLikes": 0,
    "topic": "שברים במודלים שונים",
    "app_eng": "Fraction Circle Model",
    "top_topic": "שבר",
    "studentScores": 0
  },
  {
    "classes": "45",
    "lesson_id": "12222",
    "app": "מלחמת שברים",
    "plus": "1",
    "app_topic": "השוואת שברים",
    "app_arabic": "حَرْب الْكُسُور ",
    "search_words": "שבר",
    "youtube": "gjDAm0V9qO8",
    "father_app": "Fraction_circle_model",
    "interaction": "0",
    "teacher_page": "מלחמת שברים - למורה",
    "teacher_page_ar": "מלחמת שברים - למורה - בערבית",
    "student_page": "מלחמת שברים - דפי משימה",
    "student_page_ar": "מלחמת שברים - דפי משימה",
    "enrichment": "",
    "enrichment_ar": "",
    "arabic": "22132",
    "description": "היחידה מיועדת לתלמידים בכיתות ד-ה והיא מחולקת לשני שיעורים בני 45 דקות כל אחד, העוסקים בהשוואת שברים. בשיעור הראשון יקבלו התלמידים דפי המשימה עליהם מצויירים קלפי שברים לגזירה. על כל קלף כזה מופיע שבר הרשום בצורה הרגילה שלו ועיגול מתאים בו ניתן לראות ייצוג ויזואלי לשבר זה. התלמידים יתחלקו לזוגות וישחקו עם קלפים את \"משחק מלחמה\" (השבר הגדול מנצח בכל סיבוב). בחלק מהמקרים הם יראו מיד, לפי העין, איזה שבר הוא גדול יותר, אך במספר מקרים לא יהיה להם קל להחליט והם \"יאלצו\" להשתמש בשיקולים נוספים. ",
    "description_arabic": "هَذِهِ الْوَحْدَةُ مُعَدَّة لطلاب الصُّفُوف الرَّابِعَة وَالْخَامِسَة وَتَنْقَسِم إلَى درسين مُدَّةُ كُلِّ مِنْهُمَا 45 دَقِيقَةٌ، ويتناولان مُقَارَنَة الْكَسْر. فِي الدَّرْسِ الْأَوَّل، يَأْخُذ الطُّلاَّب أَوْرَاق عَمِل للقص، الَّتِي فِيهَا مَرْسُوم بِطاقات الْكُسُور. عَلَى كُلِّ بِطاقَةٌ مِنْ هَذِهِ البطاقات مُسَجَّل كَسْرٌ فِي شَكْلِهِ الْمُعْتَاد وَدَائِرَة مُنَاسَبَةٌ يُمْكِنُك مِنْ خِلَالِهَا رُؤْيَة تَمْثِيلٌ مَرْئِيّ لِهَذِه الْكَسْر. سَوْف يَنْقَسِم الطُّلاَّب إِلَى أَزْوَاجِ وَيَلْعَبُون بالبطاقات \"لعبة الحرب\" (يفوز الْكَسْر الْأَكْبَرِ فِي كُلِّ جولة). فِي بَعْضِ الْحَالَاتِ، سَوْف يَرَوْنَ عَلَى الْفَوْرِ بِالِاعْتِمَادِ عَلَى الْعَيْنِ، مَنْ هُوَ الْكَسْر الْأَكْبَر، وَلَكِنْ فِي بَعْضِ الْحَالَاتِ لَنْ يَكُونَ مِنْ السَّهْلِ تَحْدِيدِه وَسَيَكُون عَلَيْهِم \"استخدام\" اعْتِبَارَات إضَافِيَّة.. ",
    "flash": "https://www.yisumatica.org.il/flash?lang=he&file=flash/_fractions_general/fraction_war/swf",
    "father_app_heb": "שברים במודל העיגולים",
    "origin": "lessons",
    "liked": 0,
    "selected": 0,
    "viewed": 0,
    "totalLikes": 0,
    "topic": "שברים במודלים שונים",
    "app_eng": "Fraction Circle Model",
    "top_topic": "שבר",
    "studentScores": 0
  },
]






export const appsArr = [
  "Division_to_fraction", 
  "Whole_times_fraction_page", 
  "Bills_and_coins",
  "Inserting_numbers_games", 
  "Axis2", 
  "Hundred_board", 
  "Paralel",
  "Angle_game",
];

export const lessonsArr = [
  "12293",
  "12222",
];

